import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import Vue from "vue";
export const SET_EXTERNAL_SERVICES_INCIDENT = "SET_EXTERNAL_SERVICES_INCIDENT";
export const SET_EXTERNAL_SERVICES_INCIDENTS = "SET_EXTERNAL_SERVICES_INCIDENTS";
const mutations = {
  [SET_EXTERNAL_SERVICES_INCIDENTS]: (state, {
    externalServicesIncidents
  }) => {
    state.externalServicesIncidents.byId = externalServicesIncidents.byId;
    state.externalServicesIncidents.allIds = externalServicesIncidents.allIds;
  },
  [SET_EXTERNAL_SERVICES_INCIDENT]: (state, {
    externalServicesIncidents,
    service
  }) => {
    Vue.set(state.externalServicesIncidents.byId, service, externalServicesIncidents.byId[service]);
    const allIds = state.externalServicesIncidents.allIds;
    if (!_findInstanceProperty(allIds).call(allIds, s => s === service)) {
      Vue.set(state.externalServicesIncidents, "allIds", [...allIds, externalServicesIncidents.allIds]);
    }
  }
};
export default mutations;